import { useMytaverseEvent } from '../../../../providers';

export const useGameCastProgressBar = () => {
  const { initMessageSended, currentRoom, isStreamLoaded, currentEvent } =
    useMytaverseEvent();

  const secondStepLoading = !initMessageSended;
  const secondStepCompleted = initMessageSended;
  const thirdStepLoading = secondStepCompleted && !isStreamLoaded;
  const thirdStepCompleted = secondStepCompleted && isStreamLoaded;
  const forthStepLoading = thirdStepCompleted && !currentRoom;
  const forthStepCompleted = currentEvent?.enablePureGamecast
    ? isStreamLoaded
    : thirdStepCompleted && !!currentRoom;

  return {
    secondStepLoading,
    secondStepCompleted,
    thirdStepLoading,
    thirdStepCompleted,
    forthStepLoading,
    forthStepCompleted,
  };
};
